/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EvaluationCommentScopeFilter } from './evaluationCommentScopeFilter';


export interface EvaluationCommentIncludeFilterItems { 
    relation?: EvaluationCommentIncludeFilterItems.RelationEnum;
    scope?: EvaluationCommentScopeFilter;
}
export namespace EvaluationCommentIncludeFilterItems {
    export type RelationEnum = 'evaluation';
    export const RelationEnum = {
        Evaluation: 'evaluation' as RelationEnum
    };
}


